import { ComponentStyleConfig } from '@chakra-ui/react'
import { Dict } from '@chakra-ui/utils'
import { mode } from '@chakra-ui/theme-tools'

export const Table: ComponentStyleConfig = {
  variants: {
    rw1: (props: Dict) => ({
      thead: {
        borderBottomWidth: 'thin',
        borderBottomColor: mode(
          'rw1.light.secondary.3',
          'rw1.dark.secondary.3',
        )(props),
      },
      tr: {
        borderBottomWidth: 'thin',
        borderBottomColor: mode(
          'rw1.light.secondary.1',
          'rw1.dark.secondary.1',
        )(props),
      },
    }),
  },
  defaultProps: {
    variant: 'rw1',
  },
}
